import type React from 'react';
import { useLocation } from 'react-router-dom';
import styles from './PageLoading.module.scss';
import SvgIcon from '../SvgIcon/SvgIcon';
import { Spinner } from '@shopify/polaris';
import { 
  HomeSkeleton, 
  ChatSkeleton, 
  FAQSkeleton, 
  WidgetSkeleton,
  SettingSkeleton
} from '../PageSkeleton';

interface PageLoadingProps {
  message?: string;
  showLogo?: boolean;
}

/**
 * 页面加载态组件
 * 根据当前路径显示对应的骨架屏
 * @param message 加载提示文本
 * @param showLogo 是否显示Logo
 */
const PageLoading: React.FC<PageLoadingProps> = ({ 
  message = 'The Ecomsend Live Chat is loading ...', 
  showLogo = true 
}) => {
  const location = useLocation();
  const pathname = location?.pathname || '';

  // Auth 页面不显示骨架屏
  if (pathname.includes('/auth')) {
    return (
      <div className={styles.pageLoading}>
        <div className={styles.loadingContent}>
          {showLogo && (
            <div className={styles.logoContainer}>
              <SvgIcon name="EcomSend" width={60} height={60} className={styles.logo} />
            </div>
          )}
          <div className={styles.message}>
            {message}
          </div>
          <div className={styles.spinnerContainer}>
            <Spinner size="small" />
          </div>
        </div>
      </div>
    );
  }

  // 根据路径选择对应的骨架屏
  const renderSkeleton = () => {
    if (pathname === '/' || pathname.includes('/home')) {
      return <HomeSkeleton />;
    }
    
    if (pathname.includes('/chat')) {
      return <ChatSkeleton />;
    }
    
    if (pathname.includes('/faq')) {
      return <FAQSkeleton />;
    }
    
    if (pathname.includes('/widget-setting')) {
      return <WidgetSkeleton />;
    }
    
    if (pathname.includes('/setting')) {
      return <SettingSkeleton />;
    }
    
    // 默认骨架屏
    return <HomeSkeleton />;
  };

  return renderSkeleton();
};

export default PageLoading; 